import Vue from 'vue';
import { FAMILY_PREVIEW_EDITOR_CONFIG as CONFIG } from '@/constants/familyPreviewEditor';

class FamilyPreviewService {
  constructor() {}

  getFamilyPreview(familyName) {
    const families = Vue.localStorage.get('allFamilyPreview');

    return families.find(family => family.familyNameId === familyName);
  }

  createSvgUrl(data) {
    let frag = document.createRange().createContextualFragment(data);
    const serializer = new XMLSerializer();

    frag.childNodes.forEach(f => {
      f.childNodes.forEach(s => {
        let text = '';
        let isPoly = false;
        s.childNodes.forEach(node => {
          if (isPoly) {
            node.setAttribute('id', text.trim());
            isPoly = false;
            text = '';
          }

          if (node.childNodes.length >= 2) {
            node.childNodes.forEach(textNode => {
              text += `${textNode.textContent}`;
            });
            isPoly = true;
          }
        });
      });
    });

    let source = serializer.serializeToString(frag);

    if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
      source = source.replace(
        /^<svg/,
        '<svg xmlns="http://www.w3.org/2000/svg"'
      );
    }

    if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
      source = source.replace(
        /^<svg/,
        '<svg xmlns:xlink="http://www.w3.org/1999/xlink"'
      );
    }
    source = '<?xml version="1.0" encoding="UTF-8"?>\r\n' + source;

    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source);
  }

  getClusterName(clusterName) {
    switch (clusterName) {
      case CONFIG.clusters.allTechnologies:
        return CONFIG.clusterName.allTechnologies;

      case CONFIG.clusters.dualBand:
        return CONFIG.clusterName.dualBand;
        
      case CONFIG.clusters.enclosure:
        return CONFIG.clusterName.enclosure;

      case CONFIG.clusters.energy:
        return CONFIG.clusterName.energy;

      case CONFIG.clusters.integratedSite:
        return CONFIG.clusterName.integratedSite;

      case CONFIG.clusters.interleaved:
        return CONFIG.clusterName.interleaved;

      case CONFIG.clusters.micro:
        return CONFIG.clusterName.micro;

      case CONFIG.clusters.microwave:
        return CONFIG.clusterName.microwave;

      case CONFIG.clusters.midBand:
        return CONFIG.clusterName.midBand;

      case CONFIG.clusters.mmWave:
        return CONFIG.clusterName.mmWave;

      case CONFIG.clusters.multiBand:
        return CONFIG.clusterName.multiBand;

      case CONFIG.clusters.multiBandFdd:
        return CONFIG.clusterName.multiBandFdd;

      case CONFIG.clusters.multiOperator:
        return CONFIG.clusterName.multiOperator;

      case CONFIG.clusters.optical:
        return CONFIG.clusterName.optical;

      case CONFIG.clusters.optimized:
        return CONFIG.clusterName.optimized;

      case CONFIG.clusters.radioGateway:
        return CONFIG.clusterName.radioGateway;

      case CONFIG.clusters.router:
        return CONFIG.clusterName.router;

      case CONFIG.clusters.singleBand:
        return CONFIG.clusterName.singleBand;

      case CONFIG.clusters.singleBandFdd:
        return CONFIG.clusterName.singleBandFdd;

      case CONFIG.clusters.singleOperator:
        return CONFIG.clusterName.singleOperator;

      case CONFIG.clusters.smallCell:
        return CONFIG.clusterName.smallCell;

      case CONFIG.clusters.smallVenues:
        return CONFIG.clusterName.smallVenues;

      case CONFIG.clusters.special:
        return CONFIG.clusterName.special;

      case CONFIG.clusters.streetMiBand:
        return CONFIG.clusterName.streetMiBand;

      case CONFIG.clusters.streetMmWave:
        return CONFIG.clusterName.streetMmWave;

      case CONFIG.clusters.tripleBand:
        return CONFIG.clusterName.tripleBand;

      case CONFIG.clusters.tripleSector:
        return CONFIG.clusterName.tripleSector;

      case CONFIG.clusters.wideBand:
        return CONFIG.clusterName.wideBand;

      case CONFIG.clusters.zeroFootprint:
        return CONFIG.clusterName.zeroFootprint;

      case CONFIG.clusters.mcn:
        return CONFIG.clusterName.mcn;

      default:
        return clusterName;
    }
  }
}

export default new FamilyPreviewService();
